// Mirrors TVK.Application/Models/Addresses/State.cs on the backend, which stays the source of
// truth and rejects an address whose state does not satisfy these rules. This copy only exists so
// the form can require and size the field before the request is sent.

/** Countries where the subdivision is part of a deliverable postal address. */
export const STATE_REQUIRED_COUNTRIES = ["US", "CA", "AU"];

/** Maximum length of a free text state, matching the nvarchar(64) column. */
export const STATE_MAX_LENGTH = 64;

export function isStateRequired(countryCode?: string | null): boolean {
  if (!countryCode) return false;
  return STATE_REQUIRED_COUNTRIES.includes(countryCode.trim().toUpperCase());
}

/**
 * Finds the dropdown option of a state value. Options carry the full ISO 3166-2 code ("US-AZ") so
 * a code can never be mistaken for another country's, while the backend stores only the
 * subdivision part ("AZ"), which is what the couriers accept. Both forms are recognised.
 */
export function findStateOption<T extends { value: unknown }>(
  options: T[],
  countryCode: string | null | undefined,
  value: string | null | undefined
): T | undefined {
  const wanted = value?.trim().toUpperCase();
  if (!wanted) return undefined;

  const country = countryCode?.trim().toUpperCase();
  const prefixed = country ? `${country}-${wanted}` : undefined;

  return options.find((option) => {
    const code = String(option.value).toUpperCase();
    return code === wanted || code === prefixed;
  });
}
